@if (showToolTip) {
  <div id="tip" class="interpolatedPeriodToolTip">Interpolated Period</div>
}
<table class="table table-sticky">
  <thead>
    <tr>
      <th class="type-label">Statement Date</th>
      @for (column of columns; track trackColumn(idx, column); let idx = $index) {
        <th
                    [ngClass]="{
                        'hidden': !showHidden && (column.isHidden || !showNumbers),
                        'grayed': showHidden && (column.isHidden || !showNumbers),
                        'from-projection': columnIsProjection(column),
                        'historical-period': !columnIsProjection(column)
                    }"
          >
          <div class="column-header-date-container">
            <div class="column-menu-toggle" [ngClass]="{'show-when-open': idx === contextMenuOpenColumnIdx}" (click)="toggleColumnContextMenu(idx, $event)">
              <i class="column-menu-toggle-icon fas fa-chevron-down fa-xs"></i>
            </div>
            @if (idx === contextMenuOpenColumnIdx) {
              <ul class="dropdown-menu mt-1"
                  [style.position]="'fixed'"
                  [style.top.px]="contextMenuPosition.top"
                  [style.left.px]="contextMenuPosition.left">
                <li (click)="hideColumn($event, idx)"><span><i class="fas" [ngClass]="(showHidden && (column.isHidden || !showNumbers)) ? 'fa-eye' : 'fa-eye-slash'"></i>{{(showHidden && (column.isHidden || !showNumbers)) ? 'Unhide' : 'Hide'}} Column</span></li>
                @if (!viewOnlyMode && column?.forecastedFrameId) {
                  <li>
                    <span (click)="editPeriodColumn(column)"><i class="fas fa-pencil"></i>Edit Forecasted Period</span>
                  </li>
                }
                @if (!viewOnlyMode && column?.forecastedFrameId) {
                  <li>
                    <span (click)="duplicateForecastedPeriod(column)"><i class="fas fa-clone"></i>Duplicate Forecasted Period</span>
                  </li>
                }
                @if (!viewOnlyMode && !column?.forecastedFrameId && column?.combinedFrameId && column?.combinedColumnStatementBuilderOriginType) {
                  <li>
                    <span (click)="editPeriodColumn(column)"><i class="fas fa-pencil"></i>
                    {{column?.combinedColumnStatementBuilderOriginType === 'CALCULATED' ? 'Edit Calculated Period' : 'Edit Consolidated Period'}}
                  </span>
                </li>
              }
              @if (column.isDeletable() && !viewOnlyMode) {
                <li><span (click)="deletePeriodColumn(column)"><i class="fas fa-trash"></i>Delete Statement</span></li>
              }
              @if (columnHasComments(column)) {
                <li>
                  <span (click)="openColumnComments(column)"><i class="fas fa-comment"></i>Show Comment</span>
                </li>
              }
              @if (!viewOnlyMode && showSpreadingInContextMenu && !embeddedMode) {
                @for (doc of column.documentOptions; track doc) {
                  <li class="dropdown-divider"></li>
                  <li><span class="source-doc-section-header"><strong>{{doc.label}}</strong></span></li>
                  <li><span (click)="columnLevelContextMenuDocumentClicked(doc, $event, 'spread')"><i class="fas fa-pencil"></i>Edit Spread</span></li>
                  <li><span (click)="columnLevelContextMenuDocumentClicked(doc, $event, 'download')"><i class="fas fa-download"></i>Download Document</span></li>
                }
              }
            </ul>
          }
            <app-comment-present-indicator
              [sourceComments]="column.sourceComments"
              [tooltipTitle]="'This period has a comment on it'"
            ></app-comment-present-indicator>
            {{column.statementDate}}
          </div>
        </th>
        <th [ngClass]="{'hidden': (column.isHidden || (column.trendIsHidden && column.commonSizeIsHidden) || column.cellFormat.textFormat !== '')}"
          class="percent">
          {{column.statementDate}}
        </th>
      }
    </tr>
    <tr>
      <th class="type-label">Scenario</th>
      @for (column of columns; track trackColumn(idx, column); let idx = $index) {
        <th
                    [ngClass]="{
                        'hidden': !showHidden && (column.isHidden || !showNumbers),
                        'grayed': showHidden && (column.isHidden || !showNumbers),
                        'from-projection': columnIsProjection(column),
                        'historical-period': !columnIsProjection(column)
                    }"
        >
        {{column.scenario}}
      </th>
      <th [ngClass]="{'hidden': (column.isHidden || (column.trendIsHidden && column.commonSizeIsHidden) || column.cellFormat.textFormat !== '')}"
        class="percent">
        {{column.scenario}}
      </th>
    }
  </tr>
  @if (_projectionHelperService.atLeastOneProjectionColumnExists(columns)) {
    <tr>
      <th class="type-label">{{ (projectionScenarioTypeLabelOverride + ' Name') }}</th>
      @for (column of columns; track trackColumn(idx, column); let idx = $index) {
        <th
                    [ngClass]="{
                        'hidden': !showHidden && (column.isHidden || !showNumbers),
                        'grayed': showHidden && (column.isHidden || !showNumbers),
                        'from-projection': columnIsProjection(column),
                        'historical-period': !columnIsProjection(column)
                    }"
          [attr.data-bs-toggle]="column.projectionName ? 'tooltip' : null"
          data-bs-placement="bottom"
          data-bs-container="body"
          [attr.data-bs-title]="column.projectionName"
          >
          {{_projectionHelperService.getCondensedProjectionName(column.projectionName)}}
        </th>
        <th [ngClass]="{'hidden': (column.isHidden || (column.trendIsHidden && column.commonSizeIsHidden) || column.cellFormat.textFormat !== '')}"
          class="percent"
          [attr.data-bs-toggle]="column.projectionName ? 'tooltip' : null"
          data-bs-placement="bottom"
          data-bs-container="body"
          [attr.data-bs-title]="column.projectionName">
          {{_projectionHelperService.getCondensedProjectionName(column.projectionName)}}
        </th>
      }
    </tr>
  }
  <tr>
    <th class="type-label">Months Covered</th>
    @for (column of columns; track trackColumn(idx, column); let idx = $index) {
      <th
                    [ngClass]="{
                        'hidden': !showHidden && (column.isHidden || !showNumbers),
                        'grayed': showHidden && (column.isHidden || !showNumbers),
                        'from-projection': columnIsProjection(column),
                        'historical-period': !columnIsProjection(column)
                    }"
        >
        {{column.monthsInInterval}}
      </th>
      <th [ngClass]="{'hidden': (column.isHidden || (column.trendIsHidden && column.commonSizeIsHidden) || column.cellFormat.textFormat !== '')}"
        class="percent">
        {{column.monthsInInterval}}
      </th>
    }
  </tr>
  <tr>
    <th class="type-label">Prep Type</th>
    @for (column of columns; track trackColumn(idx, column); let idx = $index) {
      <th
                    [ngClass]="{
                        'hidden': !showHidden && (column.isHidden || !showNumbers),
                        'grayed': showHidden && (column.isHidden || !showNumbers),
                        'from-projection': columnIsProjection(column),
                        'historical-period': !columnIsProjection(column)
                    }"
        >
        {{ column.preparationType | formatPrepType }}
      </th>
      <th [ngClass]="{'hidden': (column.isHidden || (column.trendIsHidden && column.commonSizeIsHidden) ||  column.cellFormat.textFormat !== '')}"
        class="percent">
        {{ column.preparationType | formatPrepType }}
      </th>
    }
  </tr>
  <tr>
    <th [ngClass]="{'show-bottom-border': !dollarSign}"  class="type-label">Statement Type</th>
    @for (column of columns; track trackColumn(idx, column); let idx = $index) {
      <th
                  [ngClass]="{
                    'hidden': !showHidden && (column.isHidden || !showNumbers),
                    'grayed': showHidden && (column.isHidden || !showNumbers),
                    'from-projection': columnIsProjection(column),
                    'historical-period': !columnIsProjection(column),
                    'show-bottom-border': !dollarSign
                  }"
        >
        {{ column.reportingInterval | reportingPeriod}}
      </th>
      <th [ngClass]="{'hidden': (column.isHidden || column.trendIsHidden || column.cellFormat.textFormat !== ''), 'show-bottom-border': !dollarSign}"
        class="percent">
        %
      </th>
      <th [ngClass]="{'hidden': (column.isHidden || column.commonSizeIsHidden || column.cellFormat.textFormat !== ''), 'show-bottom-border': !dollarSign}"
        class="percent">
        CS
      </th>
    }
  </tr>
  @if (dollarSign) {
    <tr>
      <th class="type-label show-bottom-border">Currency</th>
      @for (column of columns; track trackColumn(idx, column); let idx = $index) {
        <th
                    [ngClass]="{
                        'hidden': !showHidden && (column.isHidden || !showNumbers),
                        'grayed': showHidden && (column.isHidden || !showNumbers),
                        'from-projection': columnIsProjection(column),
                        'historical-period': !columnIsProjection(column)
                    }"
          class="show-bottom-border"
          >
          {{ column.currencyFormat }}
        </th>
        <th [ngClass]="{'hidden': (column.isHidden || (column.trendIsHidden && column.commonSizeIsHidden) ||  column.cellFormat.textFormat !== '')}"
          class="percent show-bottom-border">
          {{ column.currencyFormat }}
        </th>
      }
    </tr>
  }
</thead>
<tbody>
  @for (row of rows; track row; let idx = $index) {
    @if (!row.isHiddenFromView && (showHidden || !row.isHidden) && isRowVisible(row)) {
      <tr
        [className]="getRowFormatClass(row.rowFormat, idx)"
        >
        @if (row.rowFormat && row.rowFormat.header) {
          <td
            class="line-item"
            (click)="toggleSectionDrawerState(row.lineItem?.id)"
            style="cursor:pointer"
            >
            <i
              [ngClass]="getClassForSectionToggle(row.lineItem?.id)"
            ></i>
            @if (getRowFormatClass(row.rowFormat, idx).includes('header-second-level')) {
              <i class="graph-check" (click)="toggleRow($event, idx)" [ngClass]="{
                  'fas fa-chart-line deselected': !row.selected,
                  'far fa-check-square selected': row.selected
              }"></i>
              <span class="line-item-toggle">{{row.label}}</span>
            } @else {
              {{row.label}}
            }
            <i
              class="fas fa hide-row header-eye-icon"
              [ngClass]="(showHidden && hiddenRowIndices.has(idx)) ? 'fa-eye' : 'fa-eye-slash'"
              (click)="hideRow($event, idx)"
            ></i>
          </td>
        }
        @if (isSourceStatement || (row.rowFormat && !row.rowFormat.header && isRowSectionExpanded(row))) {
          <td
            class="line-item"
            >
                <div class="line-item-content">
                    <i class="graph-check" (click)="toggleRow($event, idx)" [ngClass]="{
                        'fas fa-chart-line deselected': !row.selected,
                        'far fa-check-square selected': row.selected
                    }"></i>
                    @if (!parentItemIsHidden(row)) {
                      <i class="fas hide-row"
                        [ngClass]="(showHidden && hiddenRowIndices.has(idx)) ? 'fa-eye' : 'fa-eye-slash'"
                        (click)="hideRow($event, idx)"></i>
                    }
                    <span [className]="'indent indent-' + row.indentation.toString()"></span>
                    <span class="line-item-toggle" title="{{row.label}}"
                        appFsMask
                        [ngClass]="{
                            'fs-block fs-exclude': isSourceStatement
                        }"
                    >
                        {{row.label}}
                    </span>
                </div>
            </td>
        }
        @if (isSourceStatement || isRowSectionExpanded(row)) {
          @for (column of columns; track trackColumn(colIdx, column); let colIdx = $index) {
            @if (!(!showHidden && (column.isHidden || !showNumbers))) {
              <td
                class="value-cell no-padding"
                    [ngClass]="{
                        'hidden': !showHidden && (column.isHidden || !showNumbers),
                        'grayed' : showHidden && (column.isHidden || !showNumbers),
                        'from-projection': columnIsProjection(column),
                        'cell-highlighted': selectedRow == idx && selectedColumn == colIdx,
                        'insight-highlighted-cell': highlightedCellMap && highlightedCellMap[idx + '-' + colIdx],
                        'insight-selected-cell': selectedCellMap && selectedCellMap[idx + '-' + colIdx],
                        'excluded-from-calculations': column.cells[idx]?.excludedFromCalculations
                    }">
                @if (column.cells[idx] && !row.rowFormat.header && (!column.cells[idx].isHidden || showNumbers) && !row.rowFormat.isParent) {
                  <app-table-cell
                    [cell]="column.cells[idx]"
                    [sourceComments]="column.cells[idx]?.calculatedValue?.sourceComments"
                    [statementDate]="column.statementDate"
                    [idx]="idx"
                    [value]="column?.cells[idx]?.calculatedValue?.value ? column.cells[idx].calculatedValue.value : 0"
                    [allowEdit]="false"
                    [isEditing]="false"
                    [flagOnMismatch]="false"
                    [row]="row"
                    [isHeader]="row.rowFormat.header"
                    [isBold]="row.rowFormat.bold"
                    [lineItemId]="row.lineItem?.id"
                    [originalValue]="column?.cells[idx]?.calculatedValue?.originalValue ? column.cells[idx].calculatedValue.originalValue : 0"
                    [formattedValue]="column.cells[idx].formattedValue"
                    [isHighlighted]="selectedRow == idx && selectedColumn == colIdx"
                    [multiply_by_factor]="multiply_by_factor"
                    [contextMenuDocumentItems]="column.cells[idx].documentOptions"
                    (contextMenuItemSelected)="contextMenuItemSelected($event)"
                    [showSpreadingInContextMenu]="showSpreadingInContextMenu"
                    [isSourceStatement]="isSourceStatement"
                    [isTemplated]="templated"
                    (highlightCell)="selectedCell(idx, colIdx)"
                    (openFootnotes)="enterFootnotesMode($event)"
                    (insightsSelected)="insightsSelected($event)"
                    (openCommentView)="handleCellCommentView($event)"
                    [viewOnlyMode]="viewOnlyMode"
                    [insightsLoadingComplete$]="insightsLoadingComplete$"
                    [excludedFromCalculations]="column.cells[idx]?.excludedFromCalculations"
                    [excludedCellTooltipText]="excludedCellTooltipText"
                    >
                  </app-table-cell>
                }
              </td>
            }
            @if (!(column.isHidden || column.trendIsHidden || column.cellFormat.textFormat)) {
              <td
                class="value-cell no-padding percent"
                [ngClass]="{'hidden': (column.isHidden || column.trendIsHidden || column.cellFormat.textFormat !== '')}">
                {{getTrend(column, idx, row.rowFormat.header)}}
              </td>
            }
            @if (!(column.isHidden || column.commonSizeIsHidden || column.cellFormat.textFormat)) {
              <td
                class="value-cell no-padding percent"
                [ngClass]="{'hidden': (column.isHidden || column.commonSizeIsHidden || column.cellFormat.textFormat !== '')}">
                {{getCommonSize(column, idx, row.rowFormat.header)}}
              </td>
            }
          }
        } @else {
          <!-- when section drawer is closed we need these dummy table cells so that the gray highlight appears when you hover over header -->
          @for (column of columns; track trackColumn(colIdx, column); let colIdx = $index) {
            @if (row.rowFormat && row.rowFormat.header) {
              <td class="value-cell no-padding"></td>
            }
            @if (row.rowFormat && row.rowFormat.header && !(column.isHidden || column.trendIsHidden || column.cellFormat.textFormat)) {
              <td class="value-cell no-padding percent"></td>
            }
            @if (row.rowFormat && row.rowFormat.header && !(column.isHidden || column.commonSizeIsHidden || column.cellFormat.textFormat)) {
              <td class="value-cell no-padding percent"></td>
            }
          }
        }
      </tr>
    }
  }
</table>
